<script setup>
import { useGlobalStore } from '@/stores/global';

defineProps({
  data: {
    type: Object,
    required: true,
    default: () => {},
  },
});

const globalStore = useGlobalStore();
function handleApplicationClick(type) {
  globalStore.setApplicationPopup({ visible: true, type });
}
</script>

<template>
  <Button
    v-if="data && data.title"
    text
    size="small"
    :class="['header__button', `js-button-header-application-${data.type}`]"
    rounded
    variant="outlined"
    @click="handleApplicationClick(data.type)"
  >
    {{ data.title }}
  </Button>
</template>

<style scoped lang="scss">
.header__button {
  display: none;
  @include media-breakpoint-up(msmd) {
    display: inline-block;
  }
}
</style>
